module.exports = __webpack_public_path__ + "images/1.1782880901430.jpg";